import React from 'react'
import { useDrag } from 'react-dnd'
import { Avatar, Card, Tag, Tooltip, Badge } from 'antd'
import IconFont from '../../iconFont/IconFont'
import CustomDateFNS from '../../custom-date-fns/CustomDateFNS.container'
import { ArrowUpOutlined } from '@ant-design/icons'

const DraggableCard = ({
  vendedor,
  index,
  btnEntrarNaFilaCallBack,
  badgeCount = 0,
  tooltipText = '',
}) => {
  const [{ isDragging }, drag] = useDrag({
    type: 'card',
    item: () => ({ index }),
    collect: monitor => ({
      isDragging: !!monitor.isDragging(),
    }),
  })

  const handleAvatarContextMenu = e => {
    e.preventDefault()
  }

  const btnEntrarNaFila = vendedor => {
    if (btnEntrarNaFilaCallBack) btnEntrarNaFilaCallBack(vendedor)
  }

  return (
    <div
      ref={drag}
      style={{
        opacity: isDragging ? 0.5 : 1,
        backgroundColor: isDragging ? 'lightgreen' : 'white',
        transition: 'all 0.3s ease',
        transform: isDragging ? 'rotate(4deg)' : 'rotate(0deg)',
        display: isDragging ? 'none' : 'block',
      }}
    >
      <Card
        hoverable
        bodyStyle={{
          padding: 6,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 5,
        }}
        style={{
          borderRadius: 6,
          boxShadow: '0 1px 3px rgba(0,0,0,0.08)',
          textAlign: 'center',
          maxHeight: 135,
          overflow: 'hidden',
        }}
      >
        <Tooltip title={tooltipText}>
          <Badge
            dot
            offset={[-3, 34]}
            status={vendedor.status.descricao === 'casa' ? 'error' : 'success'}
          >
            <Avatar
              src={vendedor.avatar}
              size={44}
              style={{
                border: '1px solid #f0f0f0',
                borderRadius: '50%',
              }}
              onContextMenu={handleAvatarContextMenu}
            />
          </Badge>
        </Tooltip>

        <div style={{ fontWeight: 500, fontSize: 12.5, lineHeight: 1 }}>
          {vendedor.apelido.split(' ')[0]}
        </div>

        <div
          onClick={() => btnEntrarNaFila(vendedor)}
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 3,
            fontSize: 11,
            color: '#1890ff',
            cursor: 'pointer',
          }}
        >
          <ArrowUpOutlined style={{ fontSize: 12 }} />
          <span>Entrar</span>
        </div>

        <Tag
          color={vendedor.status.descricao === 'casa' ? 'red' : 'green'}
          style={{ fontSize: 10, padding: '0 5px', lineHeight: 1 }}
        >
          <IconFont
            type={vendedor.status.icon}
            size={11}
            style={{ marginRight: 3 }}
          />
          {vendedor.status.descricao}
        </Tag>

        <div style={{ fontSize: 9, color: '#888', lineHeight: 1 }}>
          <CustomDateFNS date={vendedor.status.data} interval={15} />
        </div>
      </Card>
    </div>
  )
}

export default DraggableCard
